import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { setSnackbarError, setSnackbarSuccess } from 'store/actions/global';

export function usePrevious(value) {
  const ref = useRef(null);

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}

export function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export const useCopyToClipboard = () => {
  const dispatch = useDispatch();

  // Fallback for browsers without the async Clipboard API. Fails inside
  // focus-trapped containers (e.g. an open Dialog), which is why it is
  // only the fallback.
  const legacyCopy = (text, element) => {
    const tempInput = document.createElement(element);

    tempInput.value = text;
    document.body.appendChild(tempInput);
    tempInput.select();

    const succeeded = document.execCommand('copy');

    document.body.removeChild(tempInput);

    if (!succeeded) {
      throw new Error('execCommand copy failed');
    }
  };

  const copy = async (text, element = 'input', name = 'Link') => {
    if (!text) {
      return;
    }

    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
      } else {
        legacyCopy(text, element);
      }

      dispatch(
        setSnackbarSuccess({
          message: `${name} successfully copied`,
        })
      );
    } catch (err) {
      dispatch(
        setSnackbarError({
          message: `Something went wrong, ${name} was not copied`,
        })
      );
    }
  };

  return [copy];
};
